module.exports = __webpack_public_path__ + "static/media/phds_icon.def7b507.svg";